// deployment_class: customer_env_allowed
/**
 * RequireAuth — Plan 14 §Task 5. Renders children if authenticated; otherwise
 * redirects to /auth/login with a returnTo query param. Idle/loading states
 * render a thin placeholder so the page doesn't flash.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

export function RequireAuth({ children }: { children: ReactNode }): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'idle' || status === 'loading') {
    return <div className="min-h-screen bg-paper" aria-busy="true" />;
  }

  if (status !== 'authenticated') {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/login?returnTo=${returnTo}`} replace />;
  }

  return <>{children}</>;
}
